<template>
<div id="surveyEditorContainer"></div>
</template>

<script>
import * as SurveyEditor from 'surveyjs-editor'
import 'surveyjs-editor/surveyeditor.css'

import * as SurveyKo from 'survey-knockout'
import * as widgets from 'surveyjs-widgets'

import 'inputmask/dist/inputmask/phone-codes/phone.js'

widgets.icheck(SurveyKo)
widgets.select2(SurveyKo)
widgets.inputmask(SurveyKo)
widgets.jquerybarrating(SurveyKo)
widgets.jqueryuidatepicker(SurveyKo)
widgets.nouislider(SurveyKo)
widgets.select2tagbox(SurveyKo)
widgets.signaturepad(SurveyKo)
widgets.sortablejs(SurveyKo)
widgets.ckeditor(SurveyKo)
widgets.autocomplete(SurveyKo)
widgets.bootstrapslider(SurveyKo)

export default {
  name: 'survey-editor',
  data () {
    return {
    }
  },
  props: ['data'],
  mounted () {
    let editorOptions = {
      showEmbededSurveyTab: false,
      showJSONEditorTab: false
    }
    this.editor = new SurveyEditor.SurveyEditor('surveyEditorContainer', editorOptions)
    this.editor.text = this.data
    var vm = this

    this.editor.saveSurveyFunc = function () {
      vm.$emit('save', this.text)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/survey/SurveyEditor.vue